




































































































import {
  defineComponent,
  onMounted,
  reactive,
  ref,
} from '@vue/composition-api';
import _ from 'lodash';
import { useRouter } from '@ideavivat/vivat-2';
import {
  createUser, updateUser, getUser, deleteSignature, checkInformationExists,
} from '@/api/index';
import useAuth from '@/use/useAuth';
import useAxios from '@/use/useAxios';

import StickyFooterActionBar from '@/components/StickyFooterActionBar.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonDropzoneWithAxios from '@/components/Dropzone/CommonDropzoneWithAxios.vue';

const UserEditor = defineComponent({
  components: {
    CommonModalWithPreset,
    StickyFooterActionBar,
    CommonDropzoneWithAxios,
  },
  props: {
    id: { type: [Number, String], default: -1 },
    edit: { default: false },
  },
  setup(props: any, { emit }: any) {
    const { axios } = useAxios();
    const { route, router } = useRouter();
    const { hasPermission } = useAuth();
    const confirmModal = ref(null);
    const errorModal = ref(null);
    const form: { [key: string]: any } = reactive({
      name: '',
      username: '',
      oldUsername: '',
      employeeCode: '',
      password: '',
      confirmPassword: '',
      signature_url: '',
      call: async () => {
        let result = null;
        try {
          if (props.edit) {
            result = await updateUser(route.value.params.id, {
              name: form.name,
              username: form.oldUsername === form.username ? undefined : form.username,
              password: form.password,
              employeeCode: form.employeeCode,
            });
          } else {
            result = await createUser({
              name: form.name,
              username: form.username,
              password: form.password,
              employeeCode: form.employeeCode,
              initialRoleId: route.value.params.roleId,
              active: true,
            });
          }
        } catch (e) {
          //
        } finally {
          if (result) (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'ข้อมูลเรียบร้อย' });
          else (errorModal.value as any).compose();
        }
      },
      state: {
        value: 'READY',
      },
    });
    onMounted(async () => {
      if (props.edit) {
        const result = (await getUser(route.value.params.id));
        form.name = result.data.name;
        form.username = result.data.username;
        form.oldUsername = result.data.username;
        form.employeeCode = result.data.employeeCode;
        form.signature_url = result.data.signature_url;
      }
    });

    const failedValidatedUsernameRule = ref('');
    const checkInformationHandler = _.debounce(async () => {
      const result = await checkInformationExists({ username: form.username });

      if (result.username) failedValidatedUsernameRule.value = `excluded:${form.username}`;
      else failedValidatedUsernameRule.value = '';
    }, 500);

    return {
      axios,
      form,
      confirmModal,
      errorModal,
      deleteSignature,

      failedValidatedUsernameRule,
      checkInformationHandler,
    };
  },
});

export default UserEditor;
